import "bootstrap/dist/css/bootstrap.min.css";
import { CalendarOutlined } from "@ant-design/icons";

const NoRecordsFound = ({ message = "No Records Found", className }) => {
  return (
    <div
      className={`d-flex flex-column align-items-center justify-content-center ${className}`}
      style={{ height: "40vh" }}
    >
      <div className="mb-3">
        {/* <CalendarOutlined style={{ fontSize: "78px", color: "#6c757d" }} /> */}
      </div>
      <h3
        className={` ${className}`}
        style={{ fontFamily: "poppins", color: "#A7B0B1" }}
      >
        {message}
      </h3>
    </div>
  );
};

export default NoRecordsFound;
